/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Automation_Action_Status_LabelInputs */

const en_automation_action_status_label = /** @type {(inputs: Automation_Action_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "succeeded") return /** @type {LocalizedString} */ (`Done`);
	if (i?.status === "converged") return /** @type {LocalizedString} */ (`Already done`);
	if (i?.status === "skipped") return /** @type {LocalizedString} */ (`Skipped`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Failed`);
	if (i?.status === "not_run") return /** @type {LocalizedString} */ (`Not run`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_automation_action_status_label = /** @type {(inputs: Automation_Action_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "succeeded") return /** @type {LocalizedString} */ (`Feito`);
	if (i?.status === "converged") return /** @type {LocalizedString} */ (`Já estava feito`);
	if (i?.status === "skipped") return /** @type {LocalizedString} */ (`Ignorado`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Falhou`);
	if (i?.status === "not_run") return /** @type {LocalizedString} */ (`Não executado`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "succeeded" | "Done" |
* | "converged" | "Already done" |
* | "skipped" | "Skipped" |
* | "failed" | "Failed" |
* | "not_run" | "Not run" |
* | * | "{status}" |
*
* @param {Automation_Action_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_status_label = /** @type {((inputs: Automation_Action_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_status_label(inputs)
	return pt_br2_automation_action_status_label(inputs)
});